import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Calendar, Clock } from "lucide-react";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ARTICLES } from "../content/journal";
import { SITE_URL } from "../seo/routes-meta";
import { breadcrumbLd } from "../seo/jsonld";

export default function Journal() {
  const listLd = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "Journal VIRALYA",
    url: SITE_URL + "/journal",
    blogPost: ARTICLES.map((a) => ({
      "@type": "BlogPosting",
      headline: a.title,
      url: SITE_URL + "/journal/" + a.slug,
      datePublished: a.date,
      description: a.description,
    })),
  };
  return (
    <div>
      <Seo path="/journal" jsonLd={[listLd, breadcrumbLd([{ name: "Accueil", path: "/" }, { name: "Journal", path: "/journal" }])]} />
      <Header />
      <main className="page">
        <div className="container page-narrow">
          <Link to="/" className="back-link"><ArrowLeft size={15} /> Accueil</Link>
          <span className="eyebrow"><span className="sq" />Journal</span>
          <h1 className="h2" style={{ marginBottom: "0.5rem" }}>Méthode, intégrations et preuves</h1>
          <p className="lead" style={{ marginBottom: "2.4rem", maxWidth: "60ch" }}>Pas de veille d'actualité : comment nous produisons, ce à quoi nous sommes connectés, et ce que nous pouvons prouver.</p>

          <div className="journal-list" data-testid="journal-list">
            {ARTICLES.map((a) => (
              <Link to={`/journal/${a.slug}`} key={a.slug} className="glass card journal-card" data-testid={`journal-card-${a.slug}`}>
                <span className="journal-tag">{a.tag}</span>
                <h2 className="journal-card__title">{a.title}</h2>
                <p className="journal-card__excerpt">{a.excerpt}</p>
                <div className="journal-meta">
                  <span><Calendar size={13} /> {a.dateLabel}</span>
                  <span><Clock size={13} /> {a.read}</span>
                  <span className="journal-more">Lire <ArrowRight size={14} /></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
